import React, { Component } from 'react';
import {Grid, TextField, Button , Snackbar , SnackbarContent} from '@material-ui/core';
import { login } from '../../Auth/Auth';
import { Redirect } from "react-router-dom";
import { Validator } from '../../Helpers/Validator';

const barber_icon = (

<svg height="50pt" viewBox="0 -16 512 512"  xmlns="http://www.w3.org/2000/svg"><path d="m256 60c-5.519531 0-10 4.480469-10 10s4.480469 10 10 10 10-4.480469 10-10-4.480469-10-10-10zm0 0"/><path d="m502 100h-13.820312l-16.179688-32.359375v-37.640625c0-16.542969-13.457031-30-30-30h-372c-16.542969 0-30 13.457031-30 30v37.640625l-16.179688 32.359375h-13.820312c-5.523438 0-10 4.476562-10 10v60c0 5.523438 4.476562 10 10 10h10v280h-10c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h492c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-10v-280h10c5.523438 0 10-4.476562 10-10v-60c0-5.523438-4.476562-10-10-10zm-445.820312-20h159.820312c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-156v-30c0-5.515625 4.484375-10 10-10h372c5.515625 0 10 4.484375 10 10v30h-156c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h159.820312l10 20h-419.640624zm129.820312 260h-106v-100h106zm-106 20h106v100h-106zm392 100h-266v-230c0-5.523438-4.476562-10-10-10h-126c-5.523438 0-10 4.476562-10 10v230h-20v-280h432zm20-300h-472v-40h472zm0 0"/><path d="m236 440h206c5.523438 0 10-4.476562 10-10v-200c0-5.523438-4.476562-10-10-10h-206c-5.523438 0-10 4.476562-10 10v200c0 5.523438 4.476562 10 10 10zm10-200h186v180h-186zm0 0"/><path d="m379 340c-3.199219 0-6.316406.503906-9.28125 1.464844l-17.851562-22.054688 34.90625-43.117187c3.472656-4.292969 2.8125-10.589844-1.480469-14.066407-4.292969-3.472656-10.589844-2.8125-14.066407 1.480469l-32.226562 39.8125-32.226562-39.8125c-3.476563-4.292969-9.773438-4.953125-14.066407-1.480469-4.292969 3.476563-4.953125 9.773438-1.480469 14.066407l34.90625 43.117187-17.851562 22.054688c-2.964844-.960938-6.085938-1.464844-9.28125-1.464844-16.542969 0-30 13.457031-30 30s13.457031 30 30 30 30-13.457031 30-30c0-5.839844-1.738281-11.519531-4.859375-16.335938l14.859375-18.359374 14.859375 18.359374c-3.121094 4.816407-4.859375 10.496094-4.859375 16.335938 0 16.542969 13.457031 30 30 30s30-13.457031 30-30-13.457031-30-30-30zm-80 40c-5.515625 0-10-4.484375-10-10s4.484375-10 10-10c5.417969 0 10 4.363281 10 10 0 5.515625-4.484375 10-10 10zm80 0c-5.515625 0-10-4.484375-10-10 0-5.636719 4.582031-10 10-10 5.515625 0 10 4.484375 10 10s-4.484375 10-10 10zm0 0"/></svg>
);
// <svg alt="teste" xmlns="http://www.w3.org/2000/svg" height="50pt" viewBox="-64 0 496 496" ><path d="m368 432c0-23.777344-32.046875-43.742188-88-55.070312v-8.929688h16c22.054688 0 40-17.945312 40-40v-72c13.230469 0 24-10.769531 24-24s-10.769531-24-24-24h-16v-120c0-22.054688-17.945312-40-40-40h-9.472656c.898437-2.511719 1.472656-5.183594 1.472656-8v-16c0-13.230469-10.769531-24-24-24h-128c-13.230469 0-24 10.769531-24 24v16c0 2.816406.574219 5.488281 1.472656 8h-9.472656c-22.054688 0-40 17.945312-40 40v120h-16c-13.230469 0-24 10.769531-24 24s10.769531 24 24 24v72c0 22.054688 17.945312 40 40 40h16v8.929688c-55.953125 11.328124-88 31.292968-88 55.070312 0 24.703125 35.472656 45.566406 95.230469 56.457031l1.730469 7.542969h174.078124l1.730469-7.542969c59.757813-10.890625 95.230469-31.753906 95.230469-56.457031zm-280 16v-16h192v16zm144-80v48h-96v-48zm32 48h-16v-48h16zm80-184c0 4.40625-3.59375 8-8 8h-48c-4.40625 0-8-3.59375-8-8s3.59375-8 8-8h48c4.40625 0 8 3.59375 8 8zm-264 64c0-4.40625 3.59375-8 8-8h192c4.40625 0 8 3.59375 8 8v24h-208zm208-22.527344c-2.511719-.898437-5.183594-1.472656-8-1.472656h-192c-2.816406 0-5.488281.574219-8 1.472656v-17.472656c10.414062 0 19.214844-6.710938 22.527344-16h162.953125c3.3125 9.289062 12.113281 16 22.527343 16v17.472656zm-128-209.472656v160h-24v-160zm48 160v-160h24v160zm-16 0h-16v-160h16zm112-136v120h-16c-10.414062 0-19.214844 6.710938-22.527344 16h-17.472656v-160h32c13.230469 0 24 10.769531 24 24zm-192-48v-16c0-4.40625 3.59375-8 8-8h128c4.40625 0 8 3.59375 8 8v16c0 4.40625-3.59375 8-8 8h-128c-4.40625 0-8-3.59375-8-8zm-48 48c0-13.230469 10.769531-24 24-24h32v160h-17.472656c-3.3125-9.289062-12.113282-16-22.527344-16h-16zm-40 144c0-4.40625 3.59375-8 8-8h48c4.40625 0 8 3.59375 8 8s-3.59375 8-8 8h-48c-4.40625 0-8-3.59375-8-8zm24 96v-72h16v80h240v-80h16v72c0 13.230469-10.769531 24-24 24h-224c-13.230469 0-24-10.769531-24-24zm72 40v48h-16v-48zm-104 64c0-11.921875 22.382812-28.214844 72-38.742188v22.742188h-16v48h17.625l1.703125 7.433594c-51.585937-10.394532-75.328125-27.257813-75.328125-39.433594zm93.703125 48-3.664063-16h155.921876l-3.664063 16zm166.96875-8.566406 1.703125-7.433594h17.625v-48h-16v-22.742188c49.617188 10.527344 72 26.8125 72 38.742188 0 12.175781-23.742188 29.039062-75.328125 39.433594zm0 0"/></svg>
export default class LoginForm extends Component {

  constructor() {
    super();
    this.state = {
      valid: false,
      email: "",
      password: "",
      error: false,
      message_error: ""
    }
    this.validator = new Validator();
    
  
  }

  signIn = async (e) => {
    e.preventDefault();
    let response = await login(this.state)

    if(response.status === 200) {
      localStorage.setItem('current_user', JSON.stringify(response.user));

      if(response.company) {
        localStorage.setItem('company_created', true);
        localStorage.setItem('current_company', JSON.stringify(response.company));
        localStorage.setItem('company_type', JSON.stringify(response.type));
      }
      this.setState({
        valid:true
      })
      
    } else {
      this.setState({
        error: true,
        message_error: response.data.error
      })
    }
  }

  changeUsername = (e) => {
    let email = e.target.value.trim();
    this.setState({email});
   
  }

  changePassword = (e) => {
    let password = e.target.value;
    this.setState({password});
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    this.setState({ error: false });
  };
  
  render() {
    let margin_3em={marginBottom: "3em"};
    let margin_1em={marginBottom: "1em"};
    this.validator.setValues([
      {name: "email", value: this.state.email, email:true, required: true},
      {name: "password", value: this.state.password, min: 5, required: true}
    ])
    
    if(this.state.valid) return <Redirect to="/worker" />
    return (
      <form onSubmit={this.signIn}>
      <Grid style={{textAlign: 'center'}}>
        {barber_icon}
      </Grid>
       <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={this.state.error}
          autoHideDuration={3000}
          onClose={this.handleClose}
        >
          <SnackbarContent
            aria-describedby="client-snackbar"
            message={this.state.message_error}
            style={{backgroundColor:"#B00020"}}
          />
        </Snackbar>

          <TextField
          id="email"
          label="Email"
          margin="dense"
          fullWidth
          autoComplete="off"
          style={margin_3em}
          onChange={this.changeUsername}
        />
        <TextField
          id="user_password"
          type="password"
          label="Senha"
          margin="dense"
          fullWidth
          autoComplete="off"
          style={margin_3em}
          onChange={this.changePassword}
        />
        <Button type="submit" disabled={!this.validator.check()} style={margin_1em} fullWidth variant="contained" size="medium" color="secondary">
            Login
        </Button>
      </form>
    )
  }
}
